export default {
    mapsKey: 'AIzaSyArklKrOWpGWUUVSn4pdVa_3L-jG4WJ8j0'
}


// WEBPACK FOOTER //
// ./src/components/credential.js